if (typeof customElements.get('biom-timeline-scroller') === 'undefined') {
  class BiomTimelineScroller extends HTMLElement {
    connectedCallback() {
      if (this._mounted) {
        return;
      }

      this._mounted = true;
      this.steps = Array.from(this.querySelectorAll(this.dataset.stepSelector || '.js-biom-timeline-step'));

      if (!this.steps.length) {
        return;
      }

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.steps.forEach((step) => step.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: '0px 0px -15% 0px',
          threshold: 0.35,
        }
      );

      this.steps.forEach((step, index) => {
        if (index === 0) {
          step.classList.add('is-visible');
          return;
        }

        this.observer.observe(step);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('biom-timeline-scroller', BiomTimelineScroller);
}